export const canAccessAdmin = (user) => user?.role === 'system_admin';
